import React, { useState, useEffect } from "react";
import { Form, Row, Col, Card, Button } from "react-bootstrap";
import SunEditor from "suneditor-react";
import { toast } from "react-toastify";
import SampleContentApi from "../../api/SampleContentApi";

const SampleContent = () => {
  const [contentType, setContentType] = useState("Retreat Description");
  const [language, setLanguage] = useState("english");
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);
  const sampleContentApi = new SampleContentApi();

  const defaultContent = {
    "Retreat Description": {
      english: `<div style="text-align: center;">
        <p style="color: rgb(53, 53, 53); font-size: 16px;">
          The cost is $175 per couple. A $75 deposit is due with the registration form. We are limited as to the number of couples we can accommodate, and availability is on a first come, first-serve basis. The registration cost covers dinner on Friday, three meals on Saturday, and breakfast and lunch on Sunday. It will also cover all retreat materials. Childcare is not provided.
        </p>
        <p><strong><em>All Retreat Couples must commit to attending the entire 3-day weekend’s activities.</em></strong></p>
        <p style="font-size: 20px; color: rgb(34, 34, 34);">
          Sts. Peter and Paul Church<br />386 N Castell Ave.,<br />New Braunfels, TX, 78130
        </p>
        <p>For questions, here is the contact info:</p>
        <p><a href="mailto:solizspp.lovestrong@gmail.com" target="_blank" rel="noopener noreferrer" style="color: #1155CC;">solizspp.lovestrong@gmail.com</a></p>
        <p style="color: #222222;">Phil (210-779-3096)<br />Jen (210-288-1908)</p>
        <p>Thank you!</p>
      </div>`,
      spanish: `<div style="text-align: center;">
        <p style="color: rgb(53, 53, 53); font-size: 16px;">
          El costo es de $175 por pareja. Se requiere un depósito de $75 al momento de enviar el formulario de inscripción. El número de parejas que podemos acomodar es limitado y la disponibilidad es por orden de llegada. El costo de inscripción cubre la cena del viernes, tres comidas el sábado y el desayuno y almuerzo del domingo. También cubre todos los materiales del retiro. No se proporciona cuidado de niños.
        </p>
        <p><strong><em>Todas las parejas del retiro deben comprometerse a asistir a todas las actividades del fin de semana de 3 días.</em></strong></p>
        <p style="font-size: 20px; color: rgb(34, 34, 34);">
          Iglesia de San Pedro y San Pablo<br />386 N Castell Ave.,<br />New Braunfels, TX, 78130
        </p>
        <p>Para preguntas, aquí está la información de contacto:</p>
        <p><a href="mailto:solizspp.lovestrong@gmail.com" target="_blank" rel="noopener noreferrer" style="color: #1155CC;">solizspp.lovestrong@gmail.com</a></p>
        <p style="color: #222222;">Phil (210-779-3096)<br />Jen (210-288-1908)</p>
        <p>¡Gracias!</p>
      </div>`,
    },
    "Retreat Email Message": {
      english: `<div style="text-align: center;">
        <p>Thank you for registering for the Sts. Peter and Paul LOVESTRONG Marriage retreat scheduled for October 18-20, 2024. We are excited that you will join us!</p>
        <p>If you have any questions, please reach out to us here...</p>
        <p><strong>Email: </strong><a href="mailto:solizspp.lovestrong@gmail.com" target="_blank" rel="noopener noreferrer" style="color: #1155CC;">solizspp.lovestrong@gmail.com</a></p>
        <p style="color: rgb(34, 34, 34);"><strong>Jen Soliz</strong><br />210-288-1908</p>
        <p style="color: #222222;"><strong>Phil Soliz</strong><br />210-779-3096</p>
        <p style="font-size: 12px;">Please expect to hear from us soon!</p>
        <p style="font-size: 12px;"><strong>LIVE! LOVE! STRONG!</strong></p>
      </div>`,
      spanish: `<div style="text-align: center;">
        <p>Gracias por inscribirse en el retiro matrimonial LOVESTRONG de San Pedro y San Pablo, programado del 18 al 20 de octubre de 2024. ¡Nos entusiasma que nos acompañen!</p>
        <p>Si tienes alguna pregunta, contáctanos aquí...</p>
        <p><strong>Correo electrónico: </strong><a href="mailto:solizspp.lovestrong@gmail.com" target="_blank" rel="noopener noreferrer" style="color: #1155CC;">solizspp.lovestrong@gmail.com</a></p>
        <p style="color: rgb(34, 34, 34);"><strong>Jen Soliz</strong><br />210-288-1908</p>
        <p style="color: #222222;"><strong>Phil Soliz</strong><br />210-779-3096</p>
        <p style="font-size: 12px;">Por favor, espere saber de nosotras pronto!</p>
        <p style="font-size: 12px;"><strong>¡VIVE! ¡AMA! ¡FUERTE!</strong></p>
      </div>`,
    },
    "Mission Statement": {
      english: `<p><em>"The mission of the LOVESTRONG Marriage Ministry is to support, strengthen, and nurture the Christ-centered marital bond between a man and a woman utilizing an experiential-based weekend retreat program."</em></p>`,
      spanish: `<p><em>"La misión de la Iglesia de Santa Monica y la del Ministerio de Matrimonios LOVESTRONG es el de apoyar, fortalecer y alimentar la unión centrada en Cristo, entre parejas casadas de nuestra Iglesia y Comunidad."</em></p>`,
    },
  };

  useEffect(() => {
    fetchContent();
  }, [contentType, language]);

  const fetchContent = async () => {
    setLoading(true);
    try {
      const res = await sampleContentApi.getSampleContent(
        contentType,
        language,
      );
      if (res.success && res.data) {
        setContent(res.data.content);
      } else {
        setContent(defaultContent[contentType][language]);
      }
    } catch (error) {
      toast.error("Failed to load content");
      setContent(defaultContent[contentType][language]);
    }
    setLoading(false);
  };

  const handleUpdate = async () => {
    try {
      const res = await sampleContentApi.updateSampleContent({
        contentType,
        language,
        content,
      });
      if (res.success) {
        toast.success(res.msg);
      } else {
        toast.error(res.msg);
      }
    } catch (error) {
      toast.error("An error occurred while saving.");
    }
  };

  return (
    <div className="row">
      <div className="col-sm-12">
        <div className="col-lg-12 d-flex flex-column">
          <div className="row flex-grow">
            <div className="col grid-margin stretch-card">
              <div className="card custom-card">
                <div className="card-body">
                  <div className="d-sm-flex justify-content-between align-items-start Couple_heading">
                    <div>                    <div> <h4 className="card-title">Manage Sample Content</h4></div>
                   
                 
                      <Form>
                        <Row>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Content Type</Form.Label>
                              <Form.Select
                                value={contentType}
                                onChange={(e) => setContentType(e.target.value)}
                              >
                                <option value="Retreat Description">
                                  Retreat Description
                                </option>
                                <option value="Retreat Email Message">
                                  Retreat Email Message
                                </option>
                                <option value="Mission Statement">
                                  Mission Statement
                                </option>
                              </Form.Select>
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Language</Form.Label>
                              <Form.Select
                                value={language}
                                onChange={(e) => setLanguage(e.target.value)}
                              >
                                <option value="english">English</option>
                                <option value="spanish">Spanish</option>
                              </Form.Select>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12}>
                            <Form.Group className="mb-3">
                              <Form.Label>Content Editor</Form.Label>
                              <SunEditor
                                setContents={content}
                                onChange={setContent}
                                height="400px"
                                setOptions={{
                                  buttonList: [
                                    [
                                      "undo",
                                      "redo",
                                      "font",
                                      "fontSize",
                                      "formatBlock",
                                    ],
                                    [
                                      "bold",
                                      "underline",
                                      "italic",
                                      "strike",
                                      "subscript",
                                      "superscript",
                                      "removeFormat",
                                    ],
                                    [
                                      "fontColor",
                                      "hiliteColor",
                                      "outdent",
                                      "indent",
                                      "align",
                                      "horizontalRule",
                                      "list",
                                      "table",
                                    ],
                                    [
                                      "link",
                                      "image",
                                      "video",
                                      "fullScreen",
                                      "showBlocks",
                                      "codeView",
                                      "preview",
                                      "print",
                                      "save",
                                    ],
                                  ],
                                }}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                        <div className="d-flex justify-content-end">
                          <Button
                            variant="primary"
                            onClick={handleUpdate}
                            disabled={loading}
                          >
                            {loading ? "Loading..." : "Update"}
                          </Button>
                        </div>
                      </Form>
                </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SampleContent;
